import React from "react";

/**
 * Global production error boundary.
 * Renders a graceful fallback instead of a blank screen if any descendant throws.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Caught:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg =
      (this.state.error && (this.state.error.message || String(this.state.error))) ||
      "Something went wrong.";
    return (
      <div
        data-testid="error-boundary"
        style={{
          minHeight: "100vh",
          background: "#000",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "2rem",
          fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
        }}
      >
        <div style={{ maxWidth: 520, textAlign: "center" }}>
          <div
            style={{
              width: 56,
              height: 56,
              margin: "0 auto 1.25rem",
              borderRadius: "9999px",
              background: "rgba(43,77,255,0.18)",
              border: "1px solid rgba(43,77,255,0.45)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 26,
            }}
          >
            ⚠
          </div>
          <h1
            style={{
              fontFamily: "'Outfit', system-ui, sans-serif",
              fontSize: "1.75rem",
              fontWeight: 600,
              letterSpacing: "-0.02em",
              marginBottom: "0.75rem",
            }}
          >
            Something went wrong.
          </h1>
          <p style={{ color: "#a1a1aa", fontSize: "0.95rem", lineHeight: 1.6, marginBottom: "1.5rem" }}>
            {msg}
          </p>
          <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => {
                this.reset();
                window.location.href = "/";
              }}
              style={{
                background: "linear-gradient(180deg,#3b5dff,#2342eb)",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.16)",
                borderRadius: "9999px",
                padding: "0.75rem 1.5rem",
                fontSize: "0.9rem",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Reload site
            </button>
            <a
              href="https://wa.me/917874867455"
              target="_blank"
              rel="noreferrer"
              style={{
                background: "rgba(255,255,255,0.04)",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: "9999px",
                padding: "0.75rem 1.5rem",
                fontSize: "0.9rem",
                fontWeight: 500,
                textDecoration: "none",
              }}
            >
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    );
  }
}
